module.exports = __webpack_public_path__ + "static/slide7-digitization-909f4225a7cd8ccda3bbf6d66b4e2d51.jpg";